import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Part from './part';
import PartDetail from './part-detail';
import PartUpdate from './part-update';
import PartDeleteDialog from './part-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={PartUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={PartUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={PartDetail} />
      <ErrorBoundaryRoute path={match.url} component={Part} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={PartDeleteDialog} />
  </>
);

export default Routes;
